import React from 'react';
import './EstadoVazio.css';

/**
 * Estado vazio padronizado para listas sem resultados.
 *
 * Props:
 * - titulo: título principal (padrão: "Nada por aqui")
 * - descricao: texto explicativo opcional
 * - icone: classe Font Awesome do ícone (padrão: "fa-solid fa-inbox")
 * - acao: configuração opcional do botão de ação ({ rotulo, onClick }) ou um nó React
 */
function EstadoVazio({
  titulo = 'Nada por aqui',
  descricao,
  icone = 'fa-solid fa-inbox',
  acao,
}) {
  const renderAcao = () => {
    if (!acao) return null;
    if (React.isValidElement(acao)) return acao;
    if (acao.rotulo) {
      return (
        <button type="button" className="btn-primary estado-vazio-padrao__botao" onClick={acao.onClick}>
          {acao.rotulo}
        </button>
      );
    }
    return null;
  };

  return (
    <div className="estado-vazio-padrao" role="status">
      {icone && <i className={`${icone} estado-vazio-padrao__icone`} aria-hidden="true" />}
      <h3 className="estado-vazio-padrao__titulo">{titulo}</h3>
      {descricao && <p className="estado-vazio-padrao__descricao">{descricao}</p>}
      {renderAcao()}
    </div>
  );
}

export default EstadoVazio;
